import { render, staticRenderFns } from "@/client/budget/views/mandate-signature/mandate-signature.pug?vue&type=template&id=7010b592&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/client/budget/views/mandate-signature/mandate-signature.scss?vue&type=style&index=0&id=7010b592&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7010b592",
  null
  
)

export default component.exports